import React, { useCallback, useEffect, useState } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { getNotifications } from "../../../core/data/redux/notification/_notificationAction";
import { apiPageLimit } from "../../../constants/common";
import RingGreenIcon from "../../../icons/RingGreenIcon";
import { notificationTimeFormat } from "../../../constants/date";
import { CommonPagination } from "../../../core/components/common/CommnPagination";

const Notifications: React.FC = () => {
  const { isSidebarOpen, onToggleSidebar } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();
  const dispatch: any = useDispatch();

  const notificationData = useSelector((state: any) => state.notification);
  const notificationList = notificationData?.notificationList || [];
  const totalCount = notificationData?.totalCount || 0;

  const [page, setPage] = useState<number>(1);
  const pageSize = apiPageLimit;


  useEffect(() => {
    dispatch(getNotifications({}));
  }, [dispatch]);

  const fetchProperties = useCallback(
    // debounce(
    (page: number) => {
      const params: any = { page, limit: pageSize };
      dispatch(getNotifications(params));
    },
    //   500
    // ),
    [dispatch]
  );

  // Run when page changes
  useEffect(() => {
    fetchProperties(page);
  }, [page, fetchProperties]);

  const totalPages = Math.ceil(totalCount / pageSize);


  return (
    <div className="layout">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Main Content */}
      <main className="content">
        <div className="profileSettings notifications-page-section">
          <div className="notifications-heading d-flex align-items-center gap-3 mb-3">
            <h2 className="mb-0">Notifications</h2>
          </div>

          <div className="notifications-inner-content bg-light p-4 bo">
            <div className="row">
              {notificationList?.length > 0 ? notificationList.map((item: any, index: number) => (

                <div className="col-12 mb-3">
                  <div className="notification-card success  bg-light form-control commonInput  p-4">
                    <div className="notification-content">
                      <div className="notification-icon">
                        <RingGreenIcon />
                      </div>
                      <div className="notification-text d-flex flex-column gap-2">
                        <h4>{item?.title}</h4>
                        <p>{item?.message}</p>
                      </div>
                    </div>
                    <span className="notification-time">{notificationTimeFormat(item.created_at)}</span>
                  </div>
                </div>
              ))
                :
                (
                  <div className="text-center">
                    <p className="m-4">No data available</p>
                  </div>
                )
              }
            </div>
          </div>

          {/* Pagination */}
          <CommonPagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />

        </div>
      </main>
    </div>
  );
};

export default Notifications;
